import { Product } from "./types";

export const products: Product[] = [
  {
    id: 1,
    name: "Anthilia",
    brand: "Donnafugata",
    type: "Wine",
    description: "White, dry, 0.75l., 12.5%, Italy, 2021",
    price: 50,
    stock: 55,
    photo: [
      "https://static.simplewine.ru/upload/iblock/ebc/ebc5bbfc489928f37eae2ebb8b88b430.jpg@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/45a/45abd36c8add250a0109fceb584b9919.png@x430?fmt=webp",
    ],
  },
  {
    id: 40,
    name: "Nikka Days",
    brand: "Nikka",
    type: "Whiskey",
    description: "Blended, 0.7l., 40%, Japan",
    price: 85,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/1a5/1a537e95c1cde2dacc4513ad73883791.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/1b1/1b171d2f4fe6b73050f1accc4903ae3a.png@x430?fmt=webp",
    ],
  },
  {
    id: 5,
    name: "Carolina Reserva Pinot Noir",
    brand: "Santa Carolina",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Chile, 2020",
    price: 60,
    stock: 100,
    photo: [
      "https://static.simplewine.ru/upload/iblock/299/2991c25ac475601ac7a7ed6a1253099c.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/dc9/dc993717dd9b0c7b60cd64d6fa1bc260.png@x430?fmt=webp",
    ],
  },
  {
    id: 15,
    name: "Carolina Reserva Carmenere",
    brand: "Santa Carolina",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Chile, 2019",
    price: 85,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/da0/da0ad417a3a768cda59ea8cacf27ceb1.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/8ff/8ff98da8f429c05014d14b7b3da248cd.png@x430?fmt=webp",
    ],
  },
  {
    id: 45,
    name: "Oloroso Sherry Oak",
    brand: "Kavalan",
    type: "Whiskey",
    description: "Malt, 0.7l., 46%, Taiwan",
    price: 95,
    stock: 20,
    photo: [
      "https://static.simplewine.ru/upload/iblock/810/810aa32345cfc72c93e948c26b875077.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/3e2/3e261d000b65bda556248385b1376cf5.png@x430?fmt=webp",
    ],
  },
  {
    id: 8,
    name: "Rosado",
    brand: "Finca Nueva",
    type: "Wine",
    description: "Rose, dry, 0.75l., 13%, Spain, 2019",
    price: 25,
    stock: 50,
    photo: [
      "https://static.simplewine.ru/upload/iblock/6a5/6a5652a71748c99f4a3612ff2585832d.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/630/630d7d4d97ce634c8d03b705e111f4fb.png@x430?fmt=webp",
    ],
  },
  {
    id: 2,
    name: "Gran Feudo Crianza",
    brand: "Bodegas Chivite",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Spain, 2017",
    price: 65,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/543/543ac12e1b31ccd56fc2eefc24735e85.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/27e/27e5eda51f0a1446d095fd47527ffaa6.png@x430?fmt=webp",
    ],
  },
  {
    id: 56,
    name: "Antique XO Grande Champagne",
    brand: "Thomas Hine",
    type: "Cognac",
    description: "X.O., 0.7l., 40%, France",
    price: 304,
    stock: 9,
    photo: [
      "https://static.simplewine.ru/upload/iblock/097/konyak-hine-antique-xo_1.png@x430?fmt=webp",
      "https://www.globalalco.ru/i/Thomas-Hine-Co/Hine-Antique-X-O-Grande-Champagne-in-gift-box-0-7-l--39120/55561-1604911428_source_trim.png",
    ],
  },
  {
    id: 27,
    name: "Copper Pot",
    brand: "Writers Tears",
    type: "Whiskey",
    description: "Blended, 0.7l., 40%, Ireland",
    price: 95,
    stock: 60,
    photo: [
      "https://static.simplewine.ru/upload/iblock/1ca/1ca285d74e518adfecccbba5696ef592.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/6d3/6d32e889fbae22e155436238c29115ce.png@x430?fmt=webp",
    ],
  },
  {
    id: 13,
    name: "Chianti Castiglioni",
    brand: "Frescobaldi",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Italy, 2020",
    price: 125,
    stock: 90,
    photo: [
      "https://static.simplewine.ru/upload/iblock/a03/a033676c303233f605c433053dcd51a5.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/347/3479776266093766c3c4fe1d8f0e672a.png@x430?fmt=webp",
    ],
  },
  {
    id: 78,
    name: "Crystal Head Onyx",
    brand: "Globefill Inc.",
    type: "Vodka",
    description: "0.7l., 40%, Canada",
    price: 145,
    stock: 39,
    photo: [
      "https://static.simplewine.ru/upload/iblock/2f8/2f86209406183f416f1e1697b3627b82.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/bd7/bd7fb8f4782f99d663ff432d0d011990.png@x430?fmt=webp",
    ],
  },
  {
    id: 52,
    name: "Davidoff XO",
    brand: "Davidoff",
    type: "Cognac",
    description: "X.O., 0.7l., 40%, France",
    price: 324,
    stock: 15,
    photo: [
      "https://static.simplewine.ru/upload/iblock/550/5504077067d561887914d69a2121c6c1.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/e01/e017392da3a96df55e20e35653e82374.png@x430?fmt=webp",
    ],
  },
  {
    id: 62,
    name: "Praskoveisky Extra",
    brand: "Praskoveya winery",
    type: "Cognac",
    description: "Extra, 35y.o., 0.7l., 42%, Russia",
    price: 675,
    stock: 18,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/981/aed/460_550_1/0_0_orig.jpg",
      "https://krasnostop.ru/images/detailed/4/praskov_OS_extra.jpg",
    ],
  },
  {
    id: 61,
    name: "Hennessy Privilege VSOP Refik Anadol Limited Edition",
    brand: "Hennessy",
    type: "Cognac",
    description: "V.S.O.P., 0.7l., 40%, France",
    price: 910,
    stock: 3,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/677/460_550_1/foto.jpg",
      "https://www.luxepackaginginsight.com/mediatheque/4/9/8/000111894_illustration_large.png",
    ],
  },
  {
    id: 26,
    name: "Rosebank Aged 30 Years",
    brand: "Rosebank Distillery",
    type: "Whiskey",
    description: "Single malt, 0.7l., 48%, Scotland",
    price: 110,
    stock: 45,
    photo: [
      "https://static.simplewine.ru/upload/iblock/bde/bdec925bc5529ba5e4cdcb7c0b5118c9.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/99a/99ac14db19ee87895dc986e18693727a.png@x430?fmt=webp",
    ],
  },
  {
    id: 76,
    name: "Onegin",
    brand: "Onegin",
    type: "Vodka",
    description: "V.S., 0.5l., 40%, France",
    price: 155,
    stock: 54,
    photo: [
      "https://static.simplewine.ru/upload/iblock/5ac/5ac689ca7b6de4e46b1b391c034c6e3c.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/93a/vodka-onegin_3.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/02e/vodka-onegin_2.png@x430?fmt=webp",
    ],
  },
  {
    id: 44,
    name: "Carribean Rum Cask Finish",
    brand: "Tullamore Dew",
    type: "Whiskey",
    description: "Blended, 0.7l., 43%, Ireland",
    price: 115,
    stock: 35,
    photo: [
      "https://static.simplewine.ru/upload/iblock/3a5/3a5874d06736bb2366831c20adf89531.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/03e/03e5209d2dc5474de79ddbf22c3744ac.png@x430?fmt=webp",
    ],
  },
  {
    id: 41,
    name: "Deanston 15 Years Old",
    brand: "Deanston",
    type: "Whiskey",
    description: "Single malt, 0.7l., 46%, Scotland",
    price: 75,
    stock: 20,
    photo: [
      "https://static.simplewine.ru/upload/iblock/d7e/d7e49b6f5536a8a5897bbbafca87bf28.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/a1a/a1a285c5844786e84bf5bfc095d13cb8.png@x430?fmt=webp",
    ],
  },
  {
    id: 87,
    name: "Oganyan",
    brand: "Oganyan",
    type: "Vodka",
    description: "0.5l., 40%, Armenia",
    price: 23,
    stock: 34,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/2ec/460_550_1/0_0_prod_desktop.jpg",
      "https://cdn.shopify.com/s/files/1/0569/1257/6681/products/ohany_1_grande.jpg?v=1624890533",
    ],
  },
  {
    id: 68,
    name: "Frapin VS 1270 Grande Champagne",
    brand: "Frapin",
    type: "Cognac",
    description: "V.S., 0.7l., 40%, France",
    price: 63,
    stock: 21,
    photo: [
      "https://static.simplewine.ru/upload/iblock/e18/konyak-frapin-vs-1270-grande-champagne_5.png@x430?fmt=webp",
      "https://simplewine.ru/upload/iblock/cf7/cf721f0b7ebd8b99806812fd9e4329c5.png",
    ],
  },
  {
    id: 51,
    name: "Davidoff VSOP",
    brand: "Davidoff",
    type: "Cognac",
    description: "V.S.O.P., 0.7l., 40%, France",
    price: 94,
    stock: 112,
    photo: [
      "https://static.simplewine.ru/upload/iblock/712/712185a901bbc6a15f438d2e92d46ffa.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/bfc/bfca0915fdd72c323e791b66e2911875.png@x430?fmt=webp",
    ],
  },
  {
    id: 95,
    name: "Russian Squadron Ship",
    brand: "Russian Squadron",
    type: "Vodka",
    description: "0.7l., 40%, Russia",
    price: 26,
    stock: 34,
    photo: [
      "https://alcomarket.ru/upload/iblock/2e4/017/0_0_orig.jpg",
      "https://www.alcoplaza.ru/photo/photo35822.jpeg",
    ],
  },
  {
    id: 79,
    name: "Crystal Head Aurora",
    brand: "Globefill Inc.",
    type: "Vodka",
    description: "0.7l., 40%, Canada",
    price: 174,
    stock: 7,
    photo: [
      "https://static.simplewine.ru/upload/iblock/aff/affc1a42ec9575cfa2c310e56665a4fb.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/fcf/fcfa34564282ca2891b8fd0a3830be99.png@x430?fmt=webp",
    ],
  },
  {
    id: 47,
    name: "Talisker 10 Years",
    brand: "Talisker",
    type: "Whiskey",
    description: "Malt, 0.75l., 45%, Ireland",
    price: 140,
    stock: 60,
    photo: [
      "https://static.simplewine.ru/upload/iblock/1f6/1f6a0ca8f33cbe5fdad9adf0ee7bf909.jpg@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/e9a/e9abbf3c06d42a1df0f110fe6ce95cd4.png@x430?fmt=webp",
    ],
  },
  {
    id: 57,
    name: "Family Reserve Grande Champagne",
    brand: "Thomas Hine",
    type: "Cognac",
    description: "Grande Champagne AOC, 0.7l., 42%, France",
    price: 2187,
    stock: 5,
    photo: [
      "https://static.simplewine.ru/upload/iblock/5dc/konyak-hine-family-reserve_1.png@x430?fmt=webp",
      "https://www.cru.ru/upload/resize_cache/webp/ram.watermark/44c/62b/d3f/12827/hine-family-reserve-.webp",
    ],
  },
  {
    id: 9,
    name: "Trigaio",
    brand: "Feudi di San Gregorio",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Spain, 2019",
    price: 60,
    stock: 25,
    photo: [
      "https://static.simplewine.ru/upload/iblock/2ab/2ab21a9b669356cd7902170b954fc173.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/d80/d80f9438509f68476ea4e61f7584587d.png@x430?fmt=webp",
    ],
  },
  {
    id: 12,
    name: "Condado de Oriza Tempranillo",
    brand: "Pagos del Rey",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Spain, 2020",
    price: 100,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/52b/52b8f7b5235c23a47176857b3b801c55.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/227/2274c5868adf4df9e9ab09c195271639.png@x430?fmt=webp",
    ],
  },
  {
    id: 20,
    name: "Cabernet Sauvignon",
    brand: "Achaval Ferrer",
    type: "Wine",
    description: "Red, dry, 0.75l., 14%, Argentina, 2018",
    price: 210,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/c60/c60739ca62b1c6c47c8317d297ab5de2.jpg@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/f3c/f3c0edc42cfb8b463696774ffde37724.png@x430?fmt=webp",
    ],
  },
  {
    id: 34,
    name: "Finition Prune",
    brand: "Bellevoye",
    type: "Whiskey",
    description: "Malt, 0.7l., 43%, France",
    price: 70,
    stock: 15,
    photo: [
      "https://static.simplewine.ru/upload/iblock/3fb/3fb4790199eb437692486234f74aa6dc.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/989/98985f97bbe51a27bb67ad136d0c19b5.png@x430?fmt=webp",
    ],
  },
  {
    id: 14,
    name: "Viura",
    brand: "Finca Nueva",
    type: "Wine",
    description: "White, dry, 0.75l., 13%, Spain, 2019",
    price: 150,
    stock: 75,
    photo: [
      "https://static.simplewine.ru/upload/iblock/8c7/8c7104be9d7d25e938b7a6602df4657e.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/7fd/7fdc876342307a33b679251bc3bd2bef.png@x430?fmt=webp",
    ],
  },
  {
    id: 3,
    name: "Clarendelle a par Haut-Brion Rose",
    brand: "Domaine Clarence Dillon",
    type: "Wine",
    description: "Rose, dry, 0.75l., 12%, France, 2021",
    price: 45,
    stock: 70,
    photo: [
      "https://static.simplewine.ru/upload/iblock/fab/fab49c4ecfdeda61e03fbdf4cbb3da18.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/935/9354e7e9b58d296b1c2fbcbd77daeb11.png@x430?fmt=webp",
    ],
  },
  {
    id: 17,
    name: "Rkatsiteli",
    brand: "Giuaani",
    type: "Wine",
    description: "White, dry, 0.75l., 13%, Georgia, 2019",
    price: 35,
    stock: 70,
    photo: [
      "https://static.simplewine.ru/upload/iblock/85f/85fba46386d892da70a62582e684b1c0.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/53f/53fad7834577773f02945fc9ce82583c.png@x430?fmt=webp",
    ],
  },
  {
    id: 53,
    name: "Monnet XO",
    brand: "Monnet",
    type: "Cognac",
    description: "X.O., 0.7l., 40%, France",
    price: 232,
    stock: 23,
    photo: [
      "https://static.simplewine.ru/upload/iblock/617/6170216d3dc11f9197a7a05c09277f25.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/210/2106d615a193f576b08d4afb85b4ed1f.png@x430?fmt=webp",
    ],
  },
  {
    id: 33,
    name: "Edition Tourbee",
    brand: "Bellevoye",
    type: "Whiskey",
    description: "Malt, 0.7l., 43%, France",
    price: 105,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/085/0858df1b84d732282039506a42a71a0c.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/014/0140489684e28104b92836e30596e512.png@x430?fmt=webp",
    ],
  },
  {
    id: 46,
    name: "Solist",
    brand: "Kavalan",
    type: "Whiskey",
    description: "Malt, 0.7l., 56%, Taiwan",
    price: 210,
    stock: 55,
    photo: [
      "https://static.simplewine.ru/upload/iblock/00e/00ee1b955f64708bb84ac8aa0c2f0ade.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/582/582021125d7bd929553e5feeb13a0d72.png@x430?fmt=webp",
    ],
  },
  {
    id: 50,
    name: "Tobermory Aged 23 Years",
    brand: "Tobermory",
    type: "Whiskey",
    description: "Single malt, 0.7l., 46%, Scotland",
    price: 890,
    stock: 15,
    photo: [
      "https://static.simplewine.ru/upload/iblock/9e2/9e20bcb8eb25ec1d86791d7d92795ee9.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/daf/dafb94bdf685a1bf16710e9eecee0bc0.png@x430?fmt=webp",
    ],
  },
  {
    id: 6,
    name: "Hacienda Lopez de Haro",
    brand: "Reserva",
    type: "Wine",
    description: "Red, dry, 0.75l., 14%, Spain, 2016",
    price: 80,
    stock: 75,
    photo: [
      "https://static.simplewine.ru/upload/iblock/78e/78eb2cbd8ebde713caa045d2dacd703d.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/ca0/ca0a5cf8aded2539fb5992360dc4f278.png@x430?fmt=webp",
    ],
  },
  {
    id: 30,
    name: "The Harvest",
    brand: "The Irishman",
    type: "Whiskey",
    description: "Blended, 0.7l., 40%, Ireland",
    price: 75,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/dc4/dc4c8a4680b86e21fed6661b8bca38dd.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/bd2/bd2c050b317d4d99a45a01998c7eacbb.png@x430?fmt=webp",
    ],
  },
  {
    id: 75,
    name: "Monnet VS",
    brand: "Monnet",
    type: "Cognac",
    description: "V.S., 0.05l., 40%, France",
    price: 115,
    stock: 5,
    photo: [
      "https://static.simplewine.ru/upload/iblock/bf7/bf7a48dbbaf098e6a423d8c1e04195b0.jpg@x430?fmt=webp",
      "https://www.1awhisky.de/images/product_images/popup_images/Monnet-Cognac-VS-5-cl.jpg",
    ],
  },
  {
    id: 60,
    name: "Roullet VSOP",
    brand: "Roullet",
    type: "Cognac",
    description: "V.S.O.P., 0.7l., 40%, France",
    price: 66,
    stock: 54,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/025/959/460_550_1/0_0_orig.jpg",
      "https://s2.wine.style/images_gen/711/71152/0_0_orig.jpg",
    ],
  },
  {
    id: 39,
    name: "Founder's Reserve Caribbean Cask Finish",
    brand: "The Irishman",
    type: "Whiskey",
    description: "Blended, 0.7l., 46%, Ireland",
    price: 70,
    stock: 35,
    photo: [
      "https://static.simplewine.ru/upload/iblock/f10/f101aaf3d26af7a763da0d6dea4a7ed4.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/da0/da0b9cdbb032b669767206a4020b6aab.png@x430?fmt=webp",
    ],
  },
  {
    id: 32,
    name: "Finition Sauternes",
    brand: "Bellevoye",
    type: "Whiskey",
    description: "Malt, 0.7l., 40%, France",
    price: 60,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/cba/cbaa0168750b780cfe1953fb38c16249.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/9f9/9f9edcd5319fbaa66e05409a9db35fa1.png@x430?fmt=webp",
    ],
  },
  {
    id: 4,
    name: "Hito",
    brand: "Bodegas",
    type: "Wine",
    description: "Red, dry, 0.75l., 14%, Spain, 2020",
    price: 70,
    stock: 35,
    photo: [
      "https://static.simplewine.ru/upload/iblock/1ba/1bafc4f12f75345fd7fa7a95d3b5afde.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/6ab/6ab5609d0bd5cdec65586163bab39b66.png@x430?fmt=webp",
    ],
  },
  {
    id: 54,
    name: "Domaines Hine Bonneuil Grande Champagne",
    brand: "Thomas Hine",
    type: "Cognac",
    description: "Vintage, 2008, 0.7l., 40%, France",
    price: 253,
    stock: 31,
    photo: [
      "https://static.simplewine.ru/upload/iblock/7a3/konyak-domaines-hine-bonneuil-grande-champagne-2008_1.png@x430?fmt=webp",
      "https://www.globalalco.ru/i/Thomas-Hine-Co/Hine-Domaines-Hine-Bonneuil-2008-Grande-Champagne-in-gift-box-0-7-l--42193/61088-1618230726_source_trim.jpg",
    ],
  },
  {
    id: 67,
    name: "Martell Cordon Bleu",
    brand: "Martell",
    type: "Cognac",
    description: "Cognac AOC, 0.7l., 40%, France",
    price: 326,
    stock: 14,
    photo: [
      "https://static.simplewine.ru/upload/iblock/f37/f37797ab39c88f443db810b1df1da87f.png@x430?fmt=webp",
      "https://www.cru.ru/upload/resize_cache/webp/ram.watermark/775/29d/cd5/45443/156A5357.webp",
    ],
  },
  {
    id: 91,
    name: "ORA",
    brand: "Ora",
    type: "Vodka",
    description: "0.7l., 40%, France",
    price: 36,
    stock: 16,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/d38/f0a/460_550_1/0_0_orig.jpg",
      "https://bestwine24.ru/image/cache/catalog/drinks/0a35f40fcda86332c6efedd681ccdbce-300x400.jpg",
    ],
  },
  {
    id: 23,
    name: "Valdeorras",
    brand: "Valdesil",
    type: "Wine",
    description: "White, dry, 0.75l., 14%, Spain, 2017",
    price: 135,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/a45/a4564610237e0f3fdc3c591b8da0025f.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/177/177fc85209bb994b7e1ee6694235e801.png@x430?fmt=webp",
    ],
  },
  {
    id: 85,
    name: "Neft",
    brand: "Neft",
    type: "Vodka",
    description: "0.7l., 40%, Austria",
    price: 56,
    stock: 37,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/c0c/460_550_1/photo_2021_07_01_19_33_41.jpg",
      "https://winehelp2.ru/upload/iblock/1ee/1ee33df8cac2b55d5edec84da15c61dd.jpg",
    ],
  },
  {
    id: 29,
    name: "Cask Strength",
    brand: "Writers Tears",
    type: "Whiskey",
    description: "Blended, 0.7l., 54%, Ireland",
    price: 80,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/fd3/fd3ea958f544ab96f30e1313b2c642c6.jpg@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/d69/d69114ca24ae93ff42e4e5b7d5511180.png@x430?fmt=webp",
    ],
  },
  {
    id: 99,
    name: "Myagkov Cranberry",
    brand: "Myagkov",
    type: "Vodka",
    description: "0.5l., 30%, Russia",
    price: 5,
    stock: 19,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/4dc/0r8hozzoc1w5l93fs65izhm61c8uy36p/460_550_1/0_0_orig546547.jpg",
      "https://avatars.mds.yandex.net/get-mpic/4397006/img_id7694345196036820812.png/orig",
    ],
  },
  {
    id: 82,
    name: "Nikka Coffey Vodka",
    brand: "Nikka",
    type: "Vodka",
    description: "0.7l., 40%, Japan",
    price: 117,
    stock: 43,
    photo: [
      "https://static.simplewine.ru/upload/iblock/7ee/vodka-nikka-coffey-vodka_1.png@x430?fmt=webp",
      "https://s2.wine.style/images_gen/104/104877/0_1_orig.jpg",
    ],
  },
  {
    id: 18,
    name: "Semillon Chardonnay",
    brand: "Rawson's Retreat",
    type: "Wine",
    description: "White, semi-dry, 0.75l., 12%, Australia, 2019",
    price: 25,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/390/390f32d36463e71fd06aec255c6ab4cd.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/a35/a3518e9b17d1e7f7a8c000866876e23d.png@x430?fmt=webp",
    ],
  },
  {
    id: 55,
    name: "Monnet VS",
    brand: "Monnet",
    type: "Cognac",
    description: "V.S., 0.35l., 40%, France",
    price: 51,
    stock: 37,
    photo: [
      "https://static.simplewine.ru/upload/iblock/837/konyak-monnet-vs_3.png@x430?fmt=webp",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRy9ITxH6i2nAm34GvG_seAUI72LzOQ-gL9Q&usqp=CAU",
    ],
  },
  {
    id: 72,
    name: "Remy Martin Louis XIII",
    brand: "Remy Martin",
    type: "Cognac",
    description: "Cognac AOC, 0.7l., 40%, France",
    price: 5000,
    stock: 1,
    photo: [
      "https://static.simplewine.ru/upload/iblock/14f/14f899d565024d5fbf0429ce409d5391.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/c73/c7385f4ebdf212814c1133d62a8cd35f.png@x430?fmt=webp",
    ],
  },
  {
    id: 49,
    name: "Miyagikyo Single Malt",
    brand: "Nikka",
    type: "Whiskey",
    description: "Blended, 0.7l., 48%, Japan",
    price: 350,
    stock: 80,
    photo: [
      "https://static.simplewine.ru/upload/iblock/c47/c47c876e79d9d425f5dc485bfec340e3.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/379/379100fc4a1f925e7eb71b8a2b8d975b.png@x430?fmt=webp",
    ],
  },
  {
    id: 65,
    name: "Plume Frapin",
    brand: "Frapin",
    type: "Cognac",
    description: "Extra, 0.7l., 40%, France",
    price: 7812,
    stock: 3,
    photo: [
      "https://static.simplewine.ru/upload/iblock/a1a/a1a57410b046b1c42d5630da02603379.png@x430?fmt=webp",
      "https://wine-shopper.ru/image/cache/catalog/subbota/119-600x600.jpg",
    ],
  },
  {
    id: 48,
    name: "Yoichi Single Malt",
    brand: "Nikka",
    type: "Whiskey",
    description: "Blended, 0.7l., 47%, Japan",
    price: 325,
    stock: 45,
    photo: [
      "https://static.simplewine.ru/upload/iblock/584/5840d041fd0a91b806deb8c6b193d0d8.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/19f/19f4cec807d0b0f476a46fb0bb32ccce.png@x430?fmt=webp",
    ],
  },
  {
    id: 80,
    name: "Onegin",
    brand: "Onegin",
    type: "Vodka",
    description: "1.5l., 40%, Russia",
    price: 62,
    stock: 91,
    photo: [
      "https://static.simplewine.ru/upload/iblock/dcc/dcc2dac407ddc70f8b3ec45793e1ae7b.png@x430?fmt=webp",
      "https://wine-shopper.ru/image/cache/catalog/2021-02-05_14-03-17-600x600.png",
    ],
  },
  {
    id: 25,
    name: "Pingus",
    brand: "Dominio de Pingus",
    type: "Wine",
    description: "Red, dry, 0.75l., 15%, Spain, 2011",
    price: 3000,
    stock: 10,
    photo: [
      "https://static.simplewine.ru/upload/iblock/420/vino-pingus-dominio-de-pingus-2011_1.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/d4b/d4b6d8452a36e87eab1397818fc75baf.png@x430?fmt=webp",
    ],
  },
  {
    id: 43,
    name: "Blue Label",
    brand: "Johnnie Walker",
    type: "Whiskey",
    description: "Blended, 0.7l., 40%, Scotland",
    price: 80,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/3dd/3ddd8d079760d1178ba7cd3671a0f62f.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/b3b/b3bf2e8370bfb1039b1147663d6d002b.png@x430?fmt=webp",
    ],
  },
  {
    id: 19,
    name: "Noa White",
    brand: "NOA",
    type: "Wine",
    description: "White, dry, 0.75l., 13%, Armenia, 2018",
    price: 30,
    stock: 45,
    photo: [
      "https://static.simplewine.ru/upload/iblock/dd9/dd986b9dcc660f16aad8a75a1b61ed27.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/bc2/bc2b5219ecc02e30ef4676b15bace4c5.png@x430?fmt=webp",
    ],
  },
  {
    id: 35,
    name: "Finition Calvados",
    brand: "Bellevoye",
    type: "Whiskey",
    description: "Malt, 0.7l., 43%, France",
    price: 70,
    stock: 15,
    photo: [
      "https://static.simplewine.ru/upload/iblock/b2a/b2aa6cb8fbb9622166b3cfdf9a4692ce.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/403/4032bf92e00c430db9ebd2d13dcb54da.png@x430?fmt=webp",
    ],
  },
  {
    id: 36,
    name: "Finition Grand Cru",
    brand: "Bellevoye",
    type: "Whiskey",
    description: "Malt, 0.7l., 43%, France",
    price: 75,
    stock: 25,
    photo: [
      "https://static.simplewine.ru/upload/iblock/022/022994375325442778d4ee484b082f0f.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/7a7/7a736ac8319c4904c4d780684e436e4c.png@x430?fmt=webp",
    ],
  },
  {
    id: 69,
    name: "Frapin VIP XO",
    brand: "Frapin",
    type: "Cognac",
    description: "X.O., 0.35l., 40%, France",
    price: 237,
    stock: 14,
    photo: [
      "https://static.simplewine.ru/upload/iblock/d35/konyak-frapin-vip-xo-grande-champagne-1er-grand-cru-du-cognac_11.png@x430?fmt=webp",
      "https://www.moscowine.ru/wvg/0028/83479.jpg",
    ],
  },
  {
    id: 37,
    name: "Cardhu Aged 12 Years Old",
    brand: "Cardhu",
    type: "Whiskey",
    description: "Single malt, 0.7l., 40%, Scotland",
    price: 55,
    stock: 60,
    photo: [
      "https://static.simplewine.ru/upload/iblock/60f/60f0c073c98b6181ab36e6dc5c23aa8d.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/9c4/9c4f67f98f21fae485a0efd65c88cd15.png@x430?fmt=webp",
    ],
  },
  {
    id: 24,
    name: "Bordeaux",
    brand: "Jean-Pierre Moueix",
    type: "Wine",
    description: "Red, dry, 0.75l., 14%, France, 2018",
    price: 135,
    stock: 40,
    photo: [
      "https://static.simplewine.ru/upload/iblock/039/039c8955c973548a61426411d2d60cc4.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/98f/98facea63397d932bb891b33b40eb0d4.png@x430?fmt=webp",
    ],
  },
  {
    id: 88,
    name: "Mont Blanc",
    brand: "Mont Blanc",
    type: "Vodka",
    description: "0.7l., 40%, France",
    price: 42,
    stock: 37,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/436/20d/460_550_1/0_0_orig.jpg",
      "https://www.alcoplaza.ru/photo_it/photo49709.jpeg",
    ],
  },
  {
    id: 21,
    name: "Beaujolais-Villages",
    brand: "Joseph Drouhin",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, France, 2020",
    price: 170,
    stock: 80,
    photo: [
      "https://static.simplewine.ru/upload/iblock/f91/f91a1abb929ea9e9ba92325f8c281f9b.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/b53/b53a2f245bac5c312f6c39d7497f2afe.png@x430?fmt=webp",
    ],
  },
  {
    id: 7,
    name: "Chardonnay",
    brand: "Fairview",
    type: "Wine",
    description: "White, dry, 0.75l., 13%, South Africa, 2020",
    price: 30,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/48f/48fd92cb1ee7043d145c2dc968ecd03d.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/fa4/fa436ccba22c0b85f2fbfc7321db350c.png@x430?fmt=webp",
    ],
  },
  {
    id: 64,
    name: "Praskoveisky OS",
    brand: "Praskoveya winery",
    type: "Cognac",
    description: "20y.o., 0.7l., 40%, Russia",
    price: 12,
    stock: 29,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/8f1/92u11ekllikax69auw7envd48eywp8yd/460_550_1/0_0_orig-_3_.jpg",
      "https://alcomarket.ru/upload/iblock/e79/8odzdmwnanse6jc6yqq4q9tbott8utv1/346346.jpg",
    ],
  },
  {
    id: 11,
    name: "Demuerte Classic",
    brand: "Demuerte",
    type: "Wine",
    description: "Red, semi-dry, 0.75l., 14%, Spain, 2019",
    price: 90,
    stock: 75,
    photo: [
      "https://static.simplewine.ru/upload/iblock/7b6/7b64a600452ad05486a15364ddb3fabb.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/233/233ccf2755d112771fd5dc11bb89680d.png@x430?fmt=webp",
    ],
  },
  {
    id: 28,
    name: "Double Oak",
    brand: "Writers Tears",
    type: "Whiskey",
    description: "Blended, 0.7l., 46%, Ireland",
    price: 70,
    stock: 115,
    photo: [
      "https://static.simplewine.ru/upload/iblock/02d/02d3343d632985675871d32079275f5c.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/318/318b1e37d9fdd933f4e6882e666662f4.png@x430?fmt=webp",
    ],
  },
  {
    id: 73,
    name: "H By Hine VSOP",
    brand: "Thomas Hine",
    type: "Cognac",
    description: "V.S.O.P., 0.7l., 40%, France",
    price: 70,
    stock: 47,
    photo: [
      "https://static.simplewine.ru/upload/iblock/d8f/d8febb8c560dd54b187411f2a7045714.png@x430?fmt=webp",
      "https://www.cru.ru/upload/resize_cache/webp/ram.watermark/cfe/edc/dd5/50059/156A6204.webp",
    ],
  },
  {
    id: 10,
    name: "Sedara",
    brand: "Donnafugata",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Italy, 2020",
    price: 90,
    stock: 75,
    photo: [
      "https://static.simplewine.ru/upload/iblock/65e/65e40e618b477bf69d29087026ee84e9.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/a70/a70bbb4f57a1c588c27975113b645328.png@x430?fmt=webp",
    ],
  },
  {
    id: 38,
    name: "Bell's Original",
    brand: "Bell's",
    type: "Whiskey",
    description: "Blended, 1l., 40%, Scotland",
    price: 55,
    stock: 60,
    photo: [
      "https://static.simplewine.ru/upload/iblock/0b6/0b65c74e8888f6862f813040297310fd.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/f6b/f6b4f90a7b46ff8db129bbbcbe2cf4c0.png@x430?fmt=webp",
    ],
  },
  {
    id: 31,
    name: "Finition Grain Fin",
    brand: "Bellevoye",
    type: "Whiskey",
    description: "Malt, 0.7l., 40%, France",
    price: 75,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/d65/d6554ecc990f4248bc85485a1341d21a.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/c53/c53485b391a80f4337b6c8634f4a78b9.png@x430?fmt=webp",
    ],
  },
  {
    id: 71,
    name: "Cigar Reserve",
    brand: "Thomas Hine",
    type: "Cognac",
    description: "X.O., 0.7l., 45%, France",
    price: 196,
    stock: 17,
    photo: [
      "https://static.simplewine.ru/upload/iblock/a32/konyak-hine-cigar-reserve-2009_1.png@x430?fmt=webp",
      "https://alcomarket.ru/upload/iblock/5e0/e9b/0_0_orig.jpg",
    ],
  },
  {
    id: 84,
    name: "Danzka Cranraz",
    brand: "Danzka",
    type: "Vodka",
    description: "0.7l., 40%, Denmark",
    price: 25,
    stock: 21,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/208/ce0/460_550_1/0_0_orig.jpg",
      "https://www.danzka.com/wp-content/uploads/2016/04/product-danzka-cranraz-07.jpg",
    ],
  },
  {
    id: 22,
    name: "Cabernet Sauvignon Vineyards",
    brand: "Trapiche",
    type: "Wine",
    description: "Red, dry, 0.75l., 13%, Argentina, 2020",
    price: 25,
    stock: 65,
    photo: [
      "https://static.simplewine.ru/upload/iblock/fd1/fd1db1968d223fa270acf585c4a11ab4.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/020/0208754761efb51052f777528af0cbbb.png@x430?fmt=webp",
    ],
  },
  {
    id: 89,
    name: "Danzka Grapefruit",
    brand: "Danzka",
    type: "Vodka",
    description: "0.7l., 40%, Denmark",
    price: 25,
    stock: 14,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/091/460_550_1/4710_470x610.jpg",
      "https://www.danzka.com/wp-content/uploads/2016/04/DANZKA_Grapefruit_drink_grapefruit.jpg",
    ],
  },
  {
    id: 16,
    name: "Xitxarello",
    brand: "Democratic Wines",
    type: "Wine",
    description: "White, semi-dry, 0.75l., 11%, Spain, 2021",
    price: 40,
    stock: 55,
    photo: [
      "https://static.simplewine.ru/upload/iblock/81e/81e776d2707346f1b18465d35bc3b5f6.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/c3d/c3da973dd6fed6f8052d28196d626434.png@x430?fmt=webp",
    ],
  },
  {
    id: 81,
    name: "Beluga Transatlantic Racing",
    brand: "Beluga",
    type: "Vodka",
    description: "0.7l., 40%, Russia",
    price: 31,
    stock: 54,
    photo: [
      "https://static.simplewine.ru/upload/iblock/27f/27f390ff62b93e6d585fcb2348f228d9.jpg@x430?fmt=webp",
      "https://spb.luding.ru/upload/resize_cache/iblock/1af/800_900_0/1af66245b04620bb596e71a54baca7a3.png",
    ],
  },
  {
    id: 92,
    name: "Summum",
    brand: "Summum",
    type: "Vodka",
    description: "0.5l., 40%, France",
    price: 38,
    stock: 25,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/d1a/3f4/460_550_1/0_0_orig.jpg",
      "https://s2.wine.style/images_gen/136/136196/0_0_orig.jpg",
    ],
  },
  {
    id: 83,
    name: "Mamont",
    brand: "Mamont",
    type: "Vodka",
    description: "0.7l., 40%, Russia",
    price: 23,
    stock: 56,
    photo: [
      "https://static.simplewine.ru/upload/iblock/71e/71e0320cdb7d3df12cb5f40cc2cf0304.jpg@x430?fmt=webp",
      "https://www.alcoplaza.ru/photo_it/photo39626.jpeg",
    ],
  },
  {
    id: 63,
    name: "Praskoveisky Pyatigorsk",
    brand: "Praskoveya winery",
    type: "Cognac",
    description: "5y.o., 0.7l., 40%, Russia",
    price: 23,
    stock: 41,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/bc3/460_550_1/1112.jpg",
      "https://alcomarket.ru/upload/iblock/716/Bez-imeni_4.jpg",
    ],
  },
  {
    id: 98,
    name: "Hitejinro",
    brand: "Jinro",
    type: "Vodka",
    description: "0.36l., 20.1%, South Korea",
    price: 11,
    stock: 4,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/a83/39d/460_550_1/0_0_orig.jpg",
      "https://s2.wine.style/images_gen/109/109135/0_1_orig.jpg",
    ],
  },
  {
    id: 86,
    name: "Royal Original",
    brand: "Royal",
    type: "Vodka",
    description: "1l., 40%, Russia",
    price: 13,
    stock: 93,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/faa/625/460_550_1/0_0_orig.jpg",
      "https://wineretail.ru/wa-data/public/shop/products/36/92/19236/images/4209/4209.970.jpg",
    ],
  },
  {
    id: 74,
    name: "Camus VS",
    brand: "Camus",
    type: "Cognac",
    description: "V.S., 0.5l., 40%, France",
    price: 41,
    stock: 36,
    photo: [
      "https://static.simplewine.ru/upload/iblock/092/092c857aea93c30dedeeaeb476a5daf9.png@x430?fmt=webp",
      "https://s2.wine.style/images_gen/504/50453/0_0_orig.jpg",
    ],
  },
  {
    id: 90,
    name: "Czechoslovakia",
    brand: "Czechoslovakia",
    type: "Vodka",
    description: "0.7l., 40%, Slovakia",
    price: 34,
    stock: 5,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/f9d/01d/460_550_1/0_0_orig.jpg",
      "https://www.qualit.sk/uploads/products/image/czechoslovakia-vodka-2-pohare-01.png",
    ],
  },
  {
    id: 66,
    name: "Martell VS",
    brand: "Martell",
    type: "Cognac",
    description: "V.S., 0.7l., 40%, France",
    price: 65,
    stock: 17,
    photo: [
      "https://static.simplewine.ru/upload/iblock/fdb/fdb253776a87247a053417536f817e14.jpg@x430?fmt=webp",
      "https://decanter.ru/image/317396-kon-iak-martell-vs-single-distillery-0-35-l-f.jpg",
    ],
  },
  {
    id: 59,
    name: "Lheraud Cognac VSOP",
    brand: "Lheraud",
    type: "Cognac",
    description: "V.S.O.P., 0.7l., 40%, France",
    price: 93,
    stock: 27,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/a69/8b4/460_550_1/0_0_orig.jpg",
      "https://luding.ru/upload/resize_cache/iblock/8b0/800_900_0/8b02463b0ea263f2c5c1d71897fc93e1.png",
    ],
  },
  {
    id: 70,
    name: "Frapin 15 years old Cask Strength",
    brand: "Frapin",
    type: "Cognac",
    description: "Grande Champagne AOC, 0.7l., 45%, France",
    price: 163,
    stock: 9,
    photo: [
      "https://static.simplewine.ru/upload/iblock/9ba/9ba1def700376de4299e521e5540485f.png@x430?fmt=webp",
      "https://static.cognac-expert.com/9535-thickbox_default/frapin-xo-15-ans-d-age-cognac.jpg",
    ],
  },
  {
    id: 93,
    name: "Sobolinaya",
    brand: "Sobolinaya",
    type: "Vodka",
    description: "0.7l., 40%, France",
    price: 109,
    stock: 32,
    photo: [
      "https://alcomarket.ru/upload/iblock/ef7/82f/x0_0_orig.jpg.pagespeed.ic.hrdukS6NoX.webp",
      "https://s2.wine.style/images_gen/936/93616/0_0_orig.jpg",
    ],
  },
  {
    id: 94,
    name: "Magic Tree Wild Basil Grape",
    brand: "Magic Tree",
    type: "Vodka",
    description: "0.5l., 40%, Armenia",
    price: 17,
    stock: 56,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/923/460_550_1/0_0_orig-_37_.jpg",
      "https://worldbranddesign.com/wp-content/uploads/2022/08/2_3000_Basil_Glass.jpg",
    ],
  },
  {
    id: 77,
    name: "Crystal Head",
    brand: "Globefill Inc.",
    type: "Vodka",
    description: "0.5l., 40%, Canada",
    price: 132,
    stock: 34,
    photo: [
      "https://static.simplewine.ru/upload/iblock/7ea/vodka-crystal-head_3.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/6c3/vodka-crystal-head_4.png@x430?fmt=webp",
    ],
  },
  {
    id: 96,
    name: "Summum Espelette Pepper Flavored",
    brand: "Summum",
    type: "Vodka",
    description: "0.75l., 40%, France",
    price: 35,
    stock: 6,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/25f/8t2ogqlghaxy0azfx9gizujo4vpcswc1/460_550_1/0_0_orig-_2_.jpg",
      "https://decanter.ru/image/268170-vodka-summum-espelette-pepper-flavored-0-75-l-mb.jpg",
    ],
  },
  {
    id: 100,
    name: "J.J. Whitley Artisanal",
    brand: "J.J. Whitley",
    type: "Vodka",
    description: "0.5l., 40%, Russia",
    price: 6,
    stock: 27,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/e3c/72b/460_550_1/0_0_orig.jpg",
      "https://vikupvin.ru/wp-content/uploads/2021/12/vikupvin_ru_lutshaja-vodka-2021-po-mneniu-expertov-4.jpg",
    ],
  },
  {
    id: 58,
    name: "Rare Fine Champagne VSOP",
    brand: "Thomas Hine",
    type: "Cognac",
    description: "V.S.O.P., 0.7l., 40%, France",
    price: 148,
    stock: 11,
    photo: [
      "https://static.simplewine.ru/upload/iblock/ab2/ab2401351c691415205da77844e5e7aa.jpg@x430?fmt=webp",
      "https://www.globalalco.ru/i/Thomas-Hine-Co/Hine-Rare-V-S-O-P-Fine-Champagne-in-gift-box-0-7-l--39109/55539-1604862620_source_trim.jpg",
    ],
  },
  {
    id: 42,
    name: "Founder's Reserve Marsala Cask Finishin",
    brand: "The Irishman",
    type: "Whiskey",
    description: "Blended, 0.7l., 46%, Ireland",
    price: 60,
    stock: 75,
    photo: [
      "https://static.simplewine.ru/upload/iblock/5ac/5acbf9ff55b78b60019103ec12268eae.png@x430?fmt=webp",
      "https://static.simplewine.ru/upload/iblock/84b/84b2e32545036fce93198b60ea00c783.png@x430?fmt=webp",
    ],
  },
  {
    id: 97,
    name: "White Owl",
    brand: "White Owl",
    type: "Vodka",
    description: "0.7l., 40%, Russia",
    price: 11,
    stock: 44,
    photo: [
      "https://alcomarket.ru/upload/resize_cache/iblock/528/fa0/460_550_1/0_0_orig.jpg",
      "https://bestwine24.ru/image/cache/catalog/drinks/82d0c742c6cd790aeb2a970401a1d4e8-300x400.jpg",
    ],
  },
];
